import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import {
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import { generateId } from "../../_utilities/internalexternalhelper";
import { DashboardPlusicon } from "../../Icons/DashboardPlusicon";
import InternalExternalTable from "../InternalExternalTable/InternalExternalTable";
import "./DynamicTableStyle.css";

const CustomDynamicTable = ({ data, moduleType, columns, receiveProps }) => {
  const [tableData, setTableData] = useState([]);
  const [tableRawData, setTableRawData] = useState([]);
  const [isDisableActions, setIsDisableActions] = useState(false);
  const [customValues, setCustomValues] = useState("");
  const initialSnackbar = { type: "", message: "" };
  const dispatch = useDispatch();

  const defaultOptions = [
    "Cloud Sourcing",
    "Employee Portal",
    "Vendor Sourcing",
    "Job Board Portal",
    "Rejected",
    "Pending",
    "Associated",
    "Resume",
    "Cover letter",
    "ID Proof",
  ];

  useEffect(() => {
    if (data.length > 0 && moduleType) {
      const cloned = data.map((e) => ({ ...e, isEdit: false }));
      setTableData(cloned);
      setTableRawData(cloned);
    } else {
      setTableData([]);
      setTableRawData([]);
      setIsDisableActions(false);
    }
  }, [data, moduleType]);

  useEffect(() => {
    if (tableData.length > 0) {
      let isFlag = tableData?.filter((x) => x.isEdit === true);
      if (isFlag.length > 0) {
        setIsDisableActions(true);
      } else {
        setIsDisableActions(false);
      }
    }
  }, [tableData, tableRawData]);

  const onTableHandler = (item, type) => {
    dispatch(updateSnackbar(initialSnackbar));
    let Array = JSON.parse(JSON.stringify(tableData));
    let Index = Array.findIndex((x) => x.id === item.id);
    if (type === "edit") {
      if (Index !== -1) {
        Array[Index].isEdit = true;
        setTableData(Array);
        // receiveProps(item, type);
      }
    } else if (type === "delete") {
      if (Index !== -1) {
        setIsDisableActions(false);
        receiveProps(null, Array[Index].id);
        Array.splice(Index, 1);
        setTableData(Array);
        setTableRawData(Array);
      }
    } else if (type === "cancel") {
      let Array1 = JSON.parse(JSON.stringify(tableRawData));
      Array1.forEach((e) => {
        e.isEdit = false;
      });
      setIsDisableActions(false);
      setTableData(Array1);
    } else if (type === "save") {
      if (Index !== -1) {
        let object = Array.filter(
          (x) =>
            x.fieldName.toLowerCase() === Array[Index].fieldName.toLowerCase(),
        );
        if (object.length > 1) {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Duplicates are not allowed",
            }),
          );
        } else if (Array[Index].fieldName === "") {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Field name is required",
            }),
          );
        } else if (Array[Index].dataType === "") {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Data type selection is required",
            }),
          );
        } else if (
          (Array[Index].customValues.length === 0 ||
            Array[Index].customValues.length < 2) &&
          Array[Index].dataType !== "Text box"
        ) {
          dispatch(
            updateSnackbar({
              type: "error",
              message:
                Array[Index].customValues.length === 0
                  ? "Values are required for this field"
                  : "Please add at least two options",
            }),
          );
        } else {
          let defaultIds =
            moduleType === "Job Postings"
              ? [1, 2, 3, 4]
              : moduleType === "Applicants"
                ? [1, 2]
                : [];
          let isDefault = defaultIds.includes(item.id);
          if (isDefault) {
            delete Array[Index].id;
          }
          Array[Index].isEdit = false;
          let emptyField =
            Array[Index].customValues[Array[Index].customValues.length - 1];
          // console.log(typeof emptyField === "object");
          if (
            Array[Index].fieldName === "Candidate status" &&
            typeof emptyField === "object" &&
            Array[Index].customValues.some(
              (value) => !value?.internal?.trim() || !value?.external?.trim(),
            )
          ) {
            dispatch(
              updateSnackbar({ type: "error", message: "Values are required" }),
            );
            return;
          }
          setTableRawData(Array);
          setTableData(Array);
          receiveProps(Array, Index);
        }
      }
    }
    setCustomValues("");
  };

  const onChangeHandler = (value, label, obj, e) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let index = Array.findIndex((x) => x.id === obj.id);
    if (index === -1) return;

    const regex = /^[a-zA-Z0-9 _-]*$/;
    if (label !== "customValues" && label !== "fieldName") {
      Array[index][label] = value;
      if (label === "dataType") {
        Array[index].customValues = [];
      }
      setTableData(Array);
    } else if (label === "fieldName") {
      if (regex.test(value)) {
        Array[index][label] = value;
        // Array[index].customValues = [];
        setTableData(Array);
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message:
              "Please enter valid Alpha-numeric character, special character accepted are _ and -",
          }),
        );
      }
    }
  };

  const addRowHandler = (e) => {
    if (e.type === "click") {
      let Array = JSON.parse(JSON.stringify(tableData));
      if (Array.length === 1) {
        let result = !Object.values(Array[0]).every(
          (o) => o === null || o === "",
        );
        if (!result) {
          Array = [];
          setTableRawData([]);
        }
      }
      let obj = JSON.parse(JSON.stringify(columns));
      let newObj = {};
      obj.forEach((e) => {
        newObj[e.name] = "";
      });
      newObj["isEdit"] = true;
      newObj["id"] = 0;
      newObj["customValues"] = [];
      newObj["searchableField"] = 0;
      newObj["fieldType"] = "custom";
      newObj["moduleId"] =
        moduleType === "Job Postings" ? 1 : moduleType === "Applicants" ? 2 : 3;
      setIsDisableActions(true);
      Array.unshift(newObj);
      setTableData(Array);
    }
  };

  const onkeyhandlerhandler = (e, name, obj) => {
    if (e.which === 13 && customValues.trim() !== "") {
      let Array = JSON.parse(JSON.stringify(tableData));
      let index = Array.findIndex((x) => x.id === obj.id);
      if (index !== -1) {
        const values = Array[index][name] || [];

        const newValue = customValues.trim().toLowerCase();

        // Case-insensitive duplicate check
        const isDuplicate = values.some(
          (v) => v.trim().toLowerCase() === newValue,
        );

        if (isDuplicate) {
          Array[index].hasCandidateStatusDuplicate = true;

          dispatch(
            updateSnackbar({
              type: "error",
              message: "Duplicates are not allowed",
            }),
          );

          setTableData(Array);
          return;
        }

        // Add unique value
        Array[index][name].push(customValues.trim());
        Array[index].hasCandidateStatusDuplicate = false;

        setCustomValues("");
        setIsDisableActions(false);
        setTableData(Array);
      }
    } else if (
      (e.which === 8 || e.which === 46) &&
      customValues.trim() === ""
    ) {
      let Array = JSON.parse(JSON.stringify(tableData));
      let index = Array.findIndex((x) => x.id === obj.id);
      if (index !== -1) {
        Array[index].hasCandidateStatusDuplicate = false;
      }
      setTableData(Array);
      setIsDisableActions(true);
    }
  };

  const updateCustomValues = (name, obj, customValues) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let index = Array.findIndex((x) => x.id === obj.id);
    if (index !== -1) {
      Array[index][name] = customValues.map((val) => {
        if (!val.id) {
          val.id = generateId(val.internal);
        }
        val.internal = val.internal.trim();
        val.external = val.external.trim();
        return val;
      });
    }
    setTableData(Array);
  };

  const onRemoveValueHandler = (e, data, list, i) => {
    let Array = JSON.parse(JSON.stringify(tableData));
    let index = Array.findIndex((x) => x.id === data.id);

    if (index !== -1) {
      Array[index].customValues.splice(i, 1);

      // clear duplicate flag after removal
      Array[index].hasCandidateStatusDuplicate = false;

      setCustomValues("");
      setTableData(Array);
    }
  };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  const isDefaultLocked = (row) => row?.fieldType === "default";
  const asYesNo = (val) => (Number(val) === 1 ? "YES" : "NO");

  // ✅ helper to generate onDisableChange handler for a given row
  const handleCandidateStatusDisableChange = (rowId) => (disabled) => {
    console.log(
      "const handleCandidateStatusDisableChange = (rowId) => (disabled)",
      rowId,
      disabled,
    );
    setTableData((prev) =>
      prev.map((row) =>
        row.id === rowId
          ? { ...row, hasCandidateStatusDuplicate: disabled }
          : row,
      ),
    );
  };

  const onCustomValueChangeHandler = (e) => {
    const value = e.target.value;
    setCustomValues(value !== " " ? value : "");
    if (value.trim() === "") {
      let updated = [...tableData];
      let index = updated.findIndex((x) => x.id === data.id);
      if (index !== -1) {
        updated[index].hasCandidateStatusDuplicate = false;
        setTableData(updated);
      }
    }
  };

  return (
    <>
      <IconButton
        color=""
        className="addRow"
        disabled={isDisableActions}
        onClick={(e) => addRowHandler(e)}
        component="label"
      >
        <DashboardPlusicon width={35} height={36} />
        <span className="addnewusertext" style={{ marginLeft: "3px" }}>New Field</span>
      </IconButton>
      <TableContainer component={Paper}>
        <Table id="inlineEditTableCustomer" aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns.map((col) => {
                return (
                  <StyledTableCell
                    className="applicantdynatablehead"
                    width={col.displayName === "Action" ? "10%" : "20%"}
                  >
                    {col.displayName}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.length > 0
              ? tableData.map((data, id) => {
                if (data.isEdit === false) {
                  return (
                    <StyledTableRow key={`row-view-${data.id}-${id}`}>
                      {columns.map((col) => {
                        if (
                          col.displayName === "Module" &&
                          col.name === "moduleId"
                        ) {
                          return (
                            <StyledTableCell width="20%">
                              {data.moduleId === "1"
                                ? "Job Postings"
                                : "Applicants"}
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Field Name" &&
                          col.name === "fieldName"
                        ) {
                          return (
                            <StyledTableCell width="20%">
                              {data.fieldName}
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Data Type" &&
                          col.name === "dataType"
                        ) {
                          return (
                            <StyledTableCell width="15%">
                              {data.dataType}
                            </StyledTableCell>
                          );
                        } else if (
                          col.name === "customValues" &&
                          data.fieldName === "Candidate status"
                        ) {
                          return (
                            <StyledTableCell width="20%">
                              <InternalExternalTable {...data} />
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Values" &&
                          col.name === "customValues"
                        ) {
                          return (
                            <StyledTableCell width="20%">
                              {data.customValues.join(", ")}
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Mandatory" &&
                          col.name === "mandatory"
                        ) {
                          const isMandatory = Number(data.mandatory) === 1;
                          return (
                            <StyledTableCell width="20%">
                              {asYesNo(data.mandatory)}
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Searchable Field" &&
                          col.name === "searchableField"
                        ) {
                          const isSearchable =
                            Number(data.searchableField) === 1;
                          return (
                            <StyledTableCell width="20%">
                              {asYesNo(data.searchableField)}
                            </StyledTableCell>
                          );
                        } else if (col.displayName === "Action") {
                          return (
                            <StyledTableCell
                              sx={{
                                width: 88,
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                px: 1,
                              }}
                            >
                              <IconButton
                                color="primary"
                                disabled={isDisableActions}
                                onClick={() => onTableHandler(data, "edit")}
                                component="label"
                              >
                                <EditIcon
                                  style={{ color: "#3E3E3E" }}
                                  className="appediticon"
                                />
                              </IconButton>
                              {data.fieldType !== "default" ? (
                                <IconButton
                                  color="primary"
                                  disabled={isDisableActions}
                                  onClick={() =>
                                    onTableHandler(data, "delete")
                                  }
                                  component="label"
                                >
                                  <DeleteIcon
                                    style={{ color: "#3E3E3E" }}
                                    className="appdeleteicon"
                                  />
                                </IconButton>
                              ) : (
                                " "
                              )}
                            </StyledTableCell>
                          );
                        } else {
                          return <StyledTableCell> </StyledTableCell>;
                        }
                      })}
                    </StyledTableRow>
                  );
                } else if (data.isEdit === true) {
                  return (
                    <StyledTableRow key={`row-edit-${data.id}-${id}`}>
                      {columns.map((col) => {
                        if (
                          col.name === "moduleId" &&
                          data.fieldType !== "default" &&
                          data.id === 0
                        ) {
                          return (
                            <StyledTableCell>
                              <Select
                                style={{ width: "100%" }}
                                id="outlined-basic"
                                value={data.module}
                                size="small"
                                name="module"
                                onChange={(e) => {
                                  onChangeHandler(
                                    e.target.value,
                                    col.name,
                                    data,
                                  );
                                }}
                              >
                                <MenuItem value="1">Job Postings</MenuItem>
                                <MenuItem value="2">Applicants</MenuItem>
                              </Select>
                            </StyledTableCell>
                          );
                        } else if (col.name === "moduleId") {
                          return (
                            <StyledTableCell width="20%">
                              {data.moduleId === "1"
                                ? "Job Postings"
                                : "Applicants"}
                            </StyledTableCell>
                          );
                        } else if (
                          col.name === "fieldName" &&
                          data.fieldType !== "default" &&
                          data.id === 0
                        ) {
                          return (
                            <StyledTableCell>
                              <TextField
                                id="outlined-basic"
                                variant="outlined"
                                autoComplete="off"
                                size="small"
                                placeholder="Field Name"
                                style={{ width: "100%", marginTop: "0px" }}
                                name="fieldName"
                                value={data.fieldName}
                                onChange={(e) => {
                                  onChangeHandler(
                                    e.target.value,
                                    col.name,
                                    data,
                                  );
                                }}
                              />
                            </StyledTableCell>
                          );
                        } else if (col.name === "fieldName") {
                          return (
                            <StyledTableCell width="20%">
                              {data.fieldName}
                            </StyledTableCell>
                          );
                        } else if (
                          col.name === "dataType" &&
                          data.fieldType !== "default"
                        ) {
                          return (
                            <StyledTableCell>
                              <div className="educationTermRangePicker">
                                <Select
                                  style={{ width: "100%" }}
                                  id="outlined-basic"
                                  size="small"
                                  value={data.dataType}
                                  name="dataType"
                                  onChange={(e) => {
                                    onChangeHandler(
                                      e.target.value,
                                      col.name,
                                      data,
                                    );
                                  }}
                                  displayEmpty
                                  renderValue={(value) => {
                                    if (value === "" || value == null) {
                                      return (
                                        <Typography
                                          sx={{ color: "text.secondary" }}
                                        >
                                          Select
                                        </Typography>
                                      );
                                    }
                                    return String(value);
                                  }}
                                >
                                  <MenuItem value="Text box">
                                    Text box
                                  </MenuItem>
                                  <MenuItem value="Single select">
                                    Single select drop down
                                  </MenuItem>
                                  <MenuItem value="Multi select">
                                    Multi select drop down
                                  </MenuItem>
                                </Select>
                              </div>
                            </StyledTableCell>
                          );
                        } else if (col.name === "dataType") {
                          return (
                            <StyledTableCell width="20%">
                              {data.dataType}
                            </StyledTableCell>
                          );
                        } else if (
                          col.name === "customValues" &&
                          data.fieldName === "Candidate status"
                        ) {
                          return (
                            <StyledTableCell width="20%">
                              <InternalExternalTable
                                {...data}
                                updateCustomValues={(customValues) =>
                                  updateCustomValues(
                                    col.name,
                                    data,
                                    customValues,
                                  )
                                }
                                // ✅ this will be called whenever duplicate state changes
                                onDisableChange={handleCandidateStatusDisableChange(
                                  data.id,
                                )}
                              />
                            </StyledTableCell>
                          );
                        } else if (
                          col.name === "customValues" &&
                          data.dataType === "Text box"
                        ) {
                          return <StyledTableCell></StyledTableCell>;
                        } else if (
                          col.name === "customValues" &&
                          data.dataType !== "Text box"
                        ) {
                          return (
                            <StyledTableCell>
                              <div className="insOptionsSection">
                                <ul>
                                  {data.customValues &&
                                    data.customValues.map((list, i) => {
                                      if (defaultOptions.includes(list)) {
                                        return (
                                          <li className="defList">{list}</li>
                                        );
                                      } else {
                                        return (
                                          <li>
                                            {list}

                                            <span
                                              onClick={(e) =>
                                                onRemoveValueHandler(
                                                  e,
                                                  data,
                                                  list,
                                                  i,
                                                )
                                              }
                                            >
                                              x
                                            </span>
                                          </li>
                                        );
                                      }
                                    })}
                                </ul>
                                <input
                                  type="text"
                                  value={customValues}
                                  onKeyUp={(e) =>
                                    onkeyhandlerhandler(e, col.name, data)
                                  }
                                  onChange={(e) => {
                                    onCustomValueChangeHandler(e);
                                  }}
                                />
                              </div>
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Mandatory" &&
                          col.name === "mandatory"
                        ) {
                          const locked = isDefaultLocked(data);
                          if (locked) {
                            return (
                              <StyledTableCell width="15%">
                                {asYesNo(data.mandatory)}
                              </StyledTableCell>
                            );
                          }
                          return (
                            <StyledTableCell width="15%">
                              <FormControl>
                                <RadioGroup
                                  row
                                  value={Number(data.mandatory)}
                                  id="editRadiobtn"
                                  onChange={(e) =>
                                    onChangeHandler(
                                      parseInt(e.target.value, 10),
                                      col.name,
                                      data,
                                    )
                                  }
                                >
                                  <FormControlLabel
                                    value={1}
                                    control={<Radio />}
                                    label="YES"
                                  />
                                  <FormControlLabel
                                    value={0}
                                    control={<Radio />}
                                    label="NO"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </StyledTableCell>
                          );
                        } else if (
                          col.displayName === "Searchable Field" &&
                          col.name === "searchableField"
                        ) {
                          const locked =
                            isDefaultLocked(data) && !data.isEdit;
                          if (locked) {
                            return (
                              <StyledTableCell width="15%">
                                {asYesNo(data.searchableField)}
                              </StyledTableCell>
                            );
                          }
                          return (
                            <StyledTableCell width="15%">
                              <FormControl>
                                <RadioGroup
                                  row
                                  value={Number(data.searchableField)}
                                  id="editRadiobtn"
                                  onChange={(e) =>
                                    onChangeHandler(
                                      parseInt(e.target.value, 10),
                                      col.name,
                                      data,
                                    )
                                  }
                                >
                                  <FormControlLabel
                                    value={1}
                                    control={<Radio />}
                                    label="YES"
                                  />
                                  <FormControlLabel
                                    value={0}
                                    control={<Radio />}
                                    label="NO"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </StyledTableCell>
                          );
                        } else if (col.displayName === "Action") {
                          return (
                            <StyledTableCell
                              sx={{
                                width: 88,
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                px: 1,
                              }}
                            >
                              <IconButton
                                color="primary"
                                onClick={() => onTableHandler(data, "save")}
                                component="label"
                                disabled={data.hasCandidateStatusDuplicate}
                              >
                                <DoneIcon style={{ color: "#3E3E3E" }} />
                              </IconButton>
                              <IconButton
                                color="primary"
                                onClick={() => onTableHandler(data, "cancel")}
                                component="label"
                              >
                                <CloseIcon style={{ color: "#3E3E3E" }} />
                              </IconButton>
                            </StyledTableCell>
                          );
                        } else {
                          return <StyledTableCell> </StyledTableCell>;
                        }
                      })}
                    </StyledTableRow>
                  );
                }
                return null;
              })
              : (
              <div className="nodata-section">
                <img
                  src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                  alt="No data"
                />
                No Custom Fields found
              </div> )
            }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default React.memo(CustomDynamicTable);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    // borderRight: "1px solid #E8E8E8",
  },
}));
